/* eslint-disable */
import React, { useEffect, useState } from "react";
import ProfileCard from "./components/employeeProfile";
import LeaveDetailsCard from "./components/leaveDetail";
import LeaveDetailsList from "./components/leaveDetailList";
import {
  Box,
  Grid,
  Paper,
  Group,
  Title,
  ThemeIcon,
  Button,
  createStyles,
} from "@mantine/core";
import { IconDashboard } from "@tabler/icons-react";
import AttendanceWidget from "./components/attendance";
import AttendanceMetricsCards from "./components/attendanceMetric";
import AttendanceTimeline from "./components/attendanceTimeLine";
import TeamMembersCard from "./components/teamMember";
import NotificationsCard from "./components/notificationList";
import DashboardTabs from "components/DashboardTabs";
import LeaveSummaryCards from "features/leave-employees/components/leavesummaryCard/leaveSummaryCard";
import { useGetUser } from "api/users/getUser";
import ResetPasswordModal from "features/user/components/UserProfile/ResetPasswordModal";
import { User } from "types";
import { useNavigate } from "react-router-dom";
import { useUser } from "hooks/useUser";
import { useGetUserPermissions } from "api/permission/getpermission";

const useStyles = createStyles((theme) => ({
  card: {
    // height: "100%",
    borderRadius: 8,
  },
  iconCircle: {
    width: 44,
    height: 44,
    borderRadius: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  teamBtn: {
    width: "100%",
    marginTop: theme.spacing.md,
  },
}));

export default function EmployeeDashboardPanel() {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const { data, isLoading }: any = useGetUser();
  const [openResetPassword, setOpenResetPassword] = useState(false);

  const user = data as User;
  const userId = user?._id ?? "";
  const { data: permResp } = useGetUserPermissions(userId);
  const permissions = permResp?.data?.permissions ?? {};
  console.log(user, "this is for testing");

  useEffect(() => {
    if (user?.requirePasswordChange) {
      setOpenResetPassword(true);
    } else {
      setOpenResetPassword(false);
    }
  }, [user]);

  const getNested = (obj: any, path: string) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc: any, key: string) => {
      return acc && acc[key] !== undefined ? acc[key] : undefined;
    }, obj);
  };

  const hasPermission = (permissionKey: string) => {
    const value = getNested(permissions, permissionKey);

    return (
      value === true ||
      (typeof value === "object" &&
        value !== null &&
        Object.values(value).some(Boolean))
    );
  };

  const TEAMDASHBOARD_PERMISSION = "dashboardAccess.view_supervisor_dashboard";

  return (
    <Grid>
      {/* <Grid.Col span={12}>
        <DashboardTabs />
      </Grid.Col> */}
      <Grid.Col xs={12} sm={6} md={6} xl={4}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <ProfileCard />
        </Box>
      </Grid.Col>

      <Grid.Col xs={12} sm={6} md={6} xl={5}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            {/* Team Dashboard Card */}
            {hasPermission(TEAMDASHBOARD_PERMISSION) && (
              <Paper className={classes.card} p="sm" radius="md" shadow="sm">
                <Group position="apart">
                  <Title order={1} style={{ fontSize: "18px" }}>
                    Team Dashboard
                  </Title>
                  {/* <ThemeIcon
                  size={48}
                  radius={999}
                  style={{
                    backgroundColor: "#fff",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                  }}
                >
                  <div
                    className={classes.iconCircle}
                    style={{ background: "#228be6", color: "#fff" }}
                  >
                    <IconDashboard size={18} />
                  </div>
                </ThemeIcon> */}
                </Group>

                <div style={{ marginTop: 0 }}>
                  <Button
                    variant="filled"
                    className={classes.teamBtn}
                    onClick={() => navigate("/director-dashboard")}
                    color="blue"
                  >
                    View Team Dashboard
                  </Button>
                </div>
              </Paper>
            )}

            {/* Leave Details List */}
            <LeaveDetailsCard />
          </Box>
        </Box>
      </Grid.Col>

      <Grid.Col xs={12} sm={12} md={12} xl={3}>
        <LeaveDetailsList />
      </Grid.Col>

      <Grid.Col xs={12} sm={6} md={12} xl={12}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <LeaveSummaryCards />
        </Box>
      </Grid.Col>

      <Grid.Col xs={12} md={4}>
        <AttendanceWidget />
      </Grid.Col>

      <Grid.Col xs={12} md={8}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <AttendanceMetricsCards />
          <AttendanceTimeline />
        </Box>
      </Grid.Col>

      {/* Removed TeamMembersCard from here since it's now above LeaveDetailsList */}
      <Grid.Col xs={12} md={6}>
        <NotificationsCard />
      </Grid.Col>

      <ResetPasswordModal
        opened={openResetPassword}
        onClose={() => setOpenResetPassword(false)}
        user={user}
      />
    </Grid>
  );
}
